$(document).ready(function() {

	$('a[href="#"]').click(function(event){
	    event.preventDefault();
	});
	
	// Password Recovery Toggle
	$('#RecoverPassword, #HideRecoverPasswordLink').click(function(){
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	});

	// Add Search Focus on display
	$('#nav-search').click(function(){
		$('#SearchDrawer').toggle();
		$('.search-form__input').focus();
	});

	// Mobile Navigation

	// Mobile Menu
	$('#mobile-button').click(function(){
		$(this).toggleClass('open');
		$('.menu-mask').toggleClass('open');
		$('.mobile-nav').toggleClass('open');
		$('body').toggleClass('open');
	});
	
	$('.menu-mask').click(function(){
		$(this).toggleClass('open');
		$('body').toggleClass('open');
		$('#mobile-button').toggleClass('open');
		$('.mobile-nav').toggleClass('open');
	});
	
	$('.mobile-nav li button, .child-pages-dropdown a').click(function(){
		$(this).toggleClass('active');
		$(this).next('div').toggleClass('open');
	});

	// Tooggle Example
	$('.click-function').click(function(){
		$(this).toggleClass("open");
		$(this).parent().find("child div next to clicked div").slideToggle();
	});

	// FAQ
	$('.faq-question').on('click', function (e) {
        var faqItem = $( e.currentTarget );

        if (faqItem.attr( 'aria-expanded') === 'true') {
            $(this).attr( 'aria-expanded', 'false');
            $(this).toggleClass('open');
            $(this).next('.faq-answer').slideToggle();
        } else {
            $(this).attr( 'aria-expanded', 'true');
            $(this).toggleClass('open');
            $(this).next('.faq-answer').slideToggle();
        }
    });

	//Same Height
	var maxHeight = 0;

	$(".card-information__text.h5, .video-info h4, .video-info p, .product-card .product-card__title").each(function(){
	if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
	});

	$(".card-information__text.h5, .video-info h4, .video-info p, .product-card .product-card__title").height(maxHeight);

});


$(document).ready(function(){

  	// Swiper JS
	var swiper1 = new Swiper(".hp-category-slider", {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
	      0: {
            slidesPerView: 1,
            spaceBetween: 20,
            slidesPerView: "auto",
          },
          530: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });

	  var swiper2 = new Swiper(".hp-testimonials", {
        
      });

});


// Inspiration Finished Pieces
var splide = new Splide( '#inspriation-slider', {
	perPage: 3,
	height   : '400px',
	type   : 'loop',
  	drag   : 'free',
	perMove: 1,
	autoWidth: true,
	focus  : 'center',
	autoplay: true,
  } );
  
  splide.mount();